import type { WarehouseRow } from '../../supplychain/framework';

type Props = { warehouses?: WarehouseRow[] };

export function WarehouseManagementPanel({ warehouses = [] }: Props) {
  return (
    <div className="space-y-3">
      {warehouses.map((w) => {
        const pct = Math.round((w.used / w.capacity) * 100);
        return (
          <div key={w.name} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
            <div className="flex items-center justify-between">
              <p className="text-sm font-medium">{w.name}</p>
              <p className="text-xs text-slate-500">{w.used.toLocaleString()} / {w.capacity.toLocaleString()} ({pct}%)</p>
            </div>
            <div className="mt-2 h-2 rounded-full bg-slate-100 dark:bg-slate-800">
              <div
                className={`h-2 rounded-full ${pct >= 85 ? 'bg-error-500' : pct >= 70 ? 'bg-warning-500' : 'bg-brand-500'}`}
                style={{ width: `${pct}%` }}
              />
            </div>
            <div className="mt-2 flex gap-4 text-xs text-slate-500">
              <span>Inbound: {w.inbound}</span>
              <span>Outbound: {w.outbound}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
